import RestaurantAbout from './RestaurantAbout';

export default RestaurantAbout;
